<template>
  <div>
    <div class="wrapper">
      <div class="animated fadeIn">
        <b-row>
          <b-col cols="12" class="mb-3">
            <b-button variant="primary" @click="$router.go(-1)" class="pull-left back-btn">Terug</b-button>
          </b-col>
        </b-row>
        <b-form @submit.prevent="addItem" id="create">
          <b-row>
            <b-col>
              <b-alert variant="danger" :show="errors">
                Er ging iets mis...
                <ul class="mt-3">
                  <li v-for="error in errors">{{error.toString()}}</li>
                </ul>
              </b-alert>
              <b-card>
                <template #header>
                  <strong>Nieuwe locatie</strong>
                </template>
                <b-row>
                  <b-col cols="12" sm="10" md="6">
                    <b-row>
                      <b-col cols="12" md="8">
                        <h5>Basisgegevens</h5>
                        <hr>
                      </b-col>
                      <b-col cols="12" sm="8" md="8">
                        <b-form-group label="Naam">
                          <b-form-input type="text" required v-model="item.name"></b-form-input>
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="12" sm="4" md="4">
                        <b-form-group label="Code">
                          <b-form-input type="text" required v-model="item.code"></b-form-input>
                        </b-form-group>
                      </b-col>
                      <b-col cols="12" sm="4" md="4">
                        <b-form-group label="Klantreferentie">
                          <b-form-input type="text" v-model="item.internal_reference"></b-form-input>
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="12" md="8">
                        <b-form-group label="Gekoppeld bedrijf">
                          <b-form-select :options="companyOptions" v-model="item.company_id"></b-form-select>
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col cols="12" sm="10" md="6" class="mb-2">
                    <b-row>
                      <b-col cols="12" md="8">
                        <h5>Adresgegevens</h5>
                        <hr>
                      </b-col>
                      <b-col cols="12" md="8">
                        <b-form-group label="Adres">
                          <b-form-input type="text" required v-model="item.address"></b-form-input>
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="12" md="3">
                        <b-form-group label="Postcode">
                          <b-form-input type="text" required v-model="item.postal_code"></b-form-input>
                        </b-form-group>
                      </b-col>
                      <b-col cols="12" md="5">
                        <b-form-group label="Plaats">
                          <b-form-input type="text" required v-model="item.city"></b-form-input>
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="12" md="4">
                        <b-form-group label="Land">
                          <b-form-select :options="countryOptions" required v-model="item.country_code"></b-form-select>
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
                <b-row class="mt-4">
                  <b-col cols="12" sm="10" md="6">
                    <b-row>
                      <b-col cols="12" md="8">
                        <h5>Transport instellingen</h5>
                        <hr>
                      </b-col>
                    </b-row>

                    <b-row v-if="hasRecurringSettings">
                      <b-col cols="12" md="8">
                        <p>Transport instellingen voor locaties die onder een bedrijf met herhaalde leveringen vallen zijn niet beschikbaar.</p>
                      </b-col>
                    </b-row>

                    <div v-else>
                      <b-row>
                        <b-col cols="12" md="8">
                            <b-form-group label="Transport op afroep">
                              <b-form-checkbox v-model="item.transport_on_demand" name="transportOnDemand" value="1" switch>
                              <span
                                v-if="item.transport_on_demand">Ja, heeft <strong>wel</strong> transport op afroep</span>
                                <span v-else>Nee, heeft <strong>geen</strong> transport op afroep</span>
                              </b-form-checkbox>
                            </b-form-group>
                        </b-col>
                      </b-row>

                      <b-row>
                        <b-col cols="12" sm="10" md="6" class="mb-2">
                          <b-form-group label="Schema actief vanaf">
                            <b-input-group>
                              <flat-pickr
                                v-model="item.settings_start_at"
                                :config="settingsStartAtInputConfig"
                                class="form-control"
                              />
                              <b-input-group-append>
                                <b-button size="sm"
                                          @click="() => {item.settings_start_at = null}">
                                  <i class="icon-trash"></i>
                                </b-button>
                              </b-input-group-append>
                            </b-input-group>
                          </b-form-group>
                        </b-col>
                      </b-row>
                    </div>
                  </b-col>
                </b-row>
              </b-card>

              <b-row class="mt-2 mb-4">
                <b-col cols="12" md="6">
                  <delivery-slot-setter create @input="item.renewal_settings = $event" />
                </b-col>
              </b-row>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="12" class="mb-4">
              <b-card>
                <b-button type="submit" variant="primary" class="mr-3" :disabled="saveButtonDisabled">Locatie opslaan</b-button>
              </b-card>
            </b-col>
          </b-row>
        </b-form>
      </div>
    </div>
  </div>
</template>
<script>
  const weekSelect = require("flatpickr/dist/plugins/weekSelect/weekSelect.js")
import DeliverySlotSetter from "../delivery-slots/DeliverySlotSetter";
import { getData, addData } from '../../api';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import {Dutch} from "flatpickr/dist/l10n/nl.js"

export default {
  name: 'company-create',
  components: { DeliverySlotSetter, flatPickr },
  data() {
    return {
      companyOptions: [],
      countryOptions: [],
      saveButtonDisabled: false,
      settingsStartAtInputConfig: {
        locale: Dutch,
        dateFormat: 'W/Y',
        weekNumbers: true,
        plugins: [new weekSelect({})],
      },
      item: {
        name: null,
        code: null,
        address: null,
        postal_code: null,
        city: null,
        country_code: null,
        company_id: null,
        renewal_settings: [],
        transport_on_demand: false,
        settings_start_at: null,
      },
      errors: null,
      options: [
        { text: 'Maandag', value: 1 },
        { text: 'Dinsdag', value: 2 },
        { text: 'Woensdag', value: 3 },
        { text: 'Donderdag', value: 4 },
        { text: 'Vrijdag', value: 5 },
        { text: 'Zaterdag', value: 6 }
      ],
    }
  },
  computed: {
    hasRecurringSettings() {
      const company = this.companyOptions.find(x => x.value === this.item.company_id);
      return company && company.has_recurring_orders;
    },
    hasPettyCashOrders() {
      const result = this.item && this.item.company.has_recurring_orders || false;
      return result;
    }
  },
  methods: {
    async getCompanyOptions() {
      const options = await getData('companies/options').then(response => response.data);
      this.companyOptions = options.data;
    },
    async getCountries() {
      const countries = await getData('countries').then(response => response.data);
      this.countryOptions = countries.data;
    },
    async addItem() {
      this.errors = null;
      this.saveButtonDisabled = true;
      const request = await addData('locations', this.item);
      if (request.status === 200) {
        this.$router.push({ name: 'locations.view', params: { id: request.data } });
      } else {
        this.errors = request.data.errors;
        this.saveButtonDisabled = false;
      }
    },
  },
  beforeMount() {
    this.getCompanyOptions();
    this.getCountries();
  }
}

</script>


<style>
  .flatpickr-input[readonly]:not([disabled]){
    background: #FFF;
  }
</style>
